import { Unsubscriber } from '@dabble/data/stores/store';

export function addListener(node: EventTarget, event: string, handler: EventListener): Unsubscriber {
  node.addEventListener(event, handler);
  return () => node.removeEventListener(event, handler);
}
